import { render, staticRenderFns } from "./ModalEditTreeFamily.vue?vue&type=template&id=3ed56248&scoped=true"
import script from "./ModalEditTreeFamily.vue?vue&type=script&lang=js"
export * from "./ModalEditTreeFamily.vue?vue&type=script&lang=js"
import style0 from "./ModalEditTreeFamily.vue?vue&type=style&index=0&id=3ed56248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed56248",
  null
  
)

export default component.exports